import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { FolderUtil } from '../utils';

/**
 * [Model] TransmittalFolderItem
 */
var TransmittalFolderItem = /*#__PURE__*/function () {
  function TransmittalFolderItem() {
    _classCallCheck(this, TransmittalFolderItem);
  }
  return _createClass(TransmittalFolderItem, null, [{
    key: "parseV2",
    value:
    /**
     * parseV2
     *
     * @param data - the object to parse
     */
    function parseV2(data) {
      var rowData = data || {};
      var entity = new TransmittalFolderItem();
      entity.actions = rowData.actions;
      entity.displayPath = FolderUtil.localizeFolderPath(rowData).displayPath;
      entity.displayPathLocId = rowData.displayPathLocId;
      entity.folderType = rowData.folderType;
      entity.hasNS = rowData.namingStandardEnabled;
      entity.hidden = rowData.hidden;
      entity.lastModifiedTime = rowData.lastModifiedTime;
      entity.lastModifiedUserId = rowData.lastModifiedUserId;
      entity.lastModifiedUserName = rowData.lastModifiedUserName;
      entity.name = rowData.name;
      entity.transmittalFolderId = rowData.transmittalFolderId;
      entity.urn = rowData.urn;
      return entity;
    }
  }]);
}();
export { TransmittalFolderItem as default };